import SalesRecordingForm from './sales-recording-form-container';

export default SalesRecordingForm;
